"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTeeTimeIntervals = void 0;
const getTeeTimeIntervals = (start_time, end_time) => {
    // get the number of minutes between start and end time
    const start = new Date(`01/01/2020 ${start_time}`);
    const end = new Date(`01/01/2020 ${end_time}`);
    const diff = end.getTime() - start.getTime();
    const minutes = diff / 1000 / 60;
    // Divide the number of minutes by every integer from 2 up to 12, until you find an integer that is less than or equal to 60 and greater than or equal to 20
    let interval = 0;
    for (let i = 2; i <= 12; i++) {
        const val = minutes / i;
        // if val is an integer, then we can use it as the interval
        if (val % 1 === 0 && val <= 60 && val >= 20) {
            interval = i;
            break;
        }
    }
    if (interval === 0) {
        for (let i = 2; i <= 12; i++) {
            if (minutes / i <= 60 && minutes / i >= 20) {
                interval = i;
                break;
            }
        }
    }
    if (interval === 0) {
        interval = 30;
    }
    const duration = minutes / interval;
    //is the duration an integer?
    const needs_rounding = duration % 1 !== 0;
    // using the intervals, the duration create an array of start and end time slots
    const slots = [];
    for (let i = 0; i < interval; i++) {
        const slot_start = new Date(start.getTime() + i * Math.round(duration) * 60000);
        const slot_end = new Date(start.getTime() + (i + 1) * Math.round(duration) * 60000);
        // if last slot, set slot_end to end_time
        if (i === interval - 1) {
            slot_end.setHours(end.getHours());
            slot_end.setMinutes(end.getMinutes());
        }
        // get the difference in minutes between the start and end time
        const slot_diff = slot_end.getTime() - slot_start.getTime();
        const slot_minutes = slot_diff / 1000 / 60;
        slots.push({
            start_time: slot_start.toTimeString().slice(0, 5),
            diff: slot_minutes,
            end_time: slot_end.toTimeString().slice(0, 5),
        });
    }
    if (slots.length === 0) {
        slots.push({
            start_time: start_time,
            diff: minutes,
            end_time: end_time,
        });
    }
    return {
        start_time,
        end_time,
        total_minutes: minutes,
        slots,
        interval: interval,
        interval_duration: Math.round(duration),
        needs_rounding,
    };
};
exports.getTeeTimeIntervals = getTeeTimeIntervals;
